module.exports = __webpack_public_path__ + "static/img/1049.40ef36d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/1049.png
// module id = Sj6I
// module chunks = 0